<template>
    <div class="form-container" data-cy="view-container">
        <div class="form-section">
            <div class="view-borderline flex flex-wrap w-full mb-2">
                <div
                    class="header-text w-full pt-3 pl-2"
                    :class="{ 'lg:w-1/5': !is_settings }"
                    data-cy="cover-detail-header"
                >
                    {{ $t('covers.view.headers.details') }}
                </div>
            </div>

            <div class="section-body px-4 w-full mb-8" data-cy="cover-details">
                <div class="flex flex-col w-full md:w-1/2 mb-2">
                    <div class="flex w-full px-2 mb-2" data-cy="cover-confirmation-source-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.cover_type') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.cover_type }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="cover-id-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.cover_id') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.cover_id }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="period-of-cover-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.cover_period') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.cover_period }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="insurance-company-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.insurance_company') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.insurance_company }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="authorized-driver-name-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.authorized_driver_names') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.authorized_driver_names }}
                        </div>
                    </div>
                </div>
                <div class="flex flex-col w-full md:w-1/2 mb-2">
                    <div class="flex w-full px-2 mb-2" data-cy="policy-holders-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.policyholders') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.policyholders }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="type-of-insurance-cover-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.insurance_cover_type') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.insurance_cover_type }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="policy-status-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.policy_status') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.policy_status }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="insurer-policy-no-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.insurer_policy_number') }}
                        </ui-label>
                        <div class="subText w-1/2 md:w-2/3">
                            {{ cover.insurer_policy_number }}
                        </div>
                    </div>
                    <div class="flex w-full px-2 mb-2" data-cy="cover-status-field">
                        <ui-label class="w-1/2 md:w-1/3">
                            {{ $t('covers.view.labels.cover_status') }}
                        </ui-label>
                        <div
                            class="subText w-1/2 md:w-2/3 font-semibold"
                            :class="{
                                'text-default-green':
                                    (cover_status == null || cover_status == 'active') &&
                                    dayjs(cover.cover_expiry_date).diff(dayjs()) > 0,
                                'text-default-gray':
                                    (cover_status == null || cover_status == 'active') &&
                                    dayjs(cover.cover_expiry_date).diff(dayjs()) <= 0,
                                'text-default-red': cover_status == 'cancel',
                            }"
                        >
                            {{
                                (cover_status == null || cover_status == 'active') &&
                                dayjs(cover.cover_expiry_date).diff(dayjs()) > 0
                                    ? $t('covers.status.active').toUpperCase()
                                    : (cover_status == null || cover_status == 'active') &&
                                        dayjs(cover.cover_expiry_date).diff(dayjs()) <= 0
                                      ? $t('covers.status.expired').toUpperCase()
                                      : cover_status == 'cancel'
                                        ? $t('covers.status.cancelled').toUpperCase()
                                        : ''
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';

export default {
    components: {
        UiLabel,
    },
    data() {
        return {
            dayjs: this.$dayjs,
        };
    },
    props: {
        cover: {
            type: Object,
            default: {},
        },
        is_settings: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        cover_status() {
            if (this.cover.cover_status === null || this.cover.cover_status === undefined) {
                return '';
            }

            return this.cover.cover_status;
        },
    },
};
</script>
